import React, { useEffect, useState } from "react";
import { collection, deleteDoc, doc, query, where, onSnapshot } from "firebase/firestore";
import { db } from "../../firebase";
import "./ClientesList.css";
import ActionMenu from "../../comunes/componentes/ActionMenu";
import { puedeHacer } from "../../utils/permisos";

export default function ClientesList({ onNuevo, onEditar, onVer, perfil }) {
  const [clientes, setClientes] = useState([]);
  const [busqueda, setBusqueda] = useState("");
  const [clienteAbiertoId, setClienteAbiertoId] = useState(null);

  const puedeCrearClientes = puedeHacer(perfil, "clientes", "crear");
  const puedeEditarClientes = puedeHacer(perfil, "clientes", "editar");
  const puedeEliminarClientes = puedeHacer(perfil, "clientes", "eliminar");

 const escucharClientes = () => {
  if (!perfil) return () => {};

  const clientesRef = collection(db, "clientes");

  const q =
    perfil.rol === "superadmin"
      ? query(clientesRef)
      : query(clientesRef, where("clienteId", "==", perfil.clienteId));

  return onSnapshot(
    q,
    (snapshot) => {
      const lista = snapshot.docs.map((docu) => ({
        firebaseId: docu.id,
        ...docu.data(),
      }));

      setClientes(lista);
    },
    (error) => {
      console.error("Error escuchando clientes:", error);
    }
  );
};

useEffect(() => {
  const unsubscribe = escucharClientes();
  return () => unsubscribe();
}, [perfil]);

  const eliminarCliente = async (id) => {
    if (!puedeEliminarClientes) return;
    if (window.confirm("¿Seguro que querés eliminar este cliente?")) {
      try {
        await deleteDoc(doc(db, "clientes", id));
    
        
      } catch (e) {
        console.error("Error al eliminar cliente:", e);
      }
    }
  };

  const clientesFiltrados = clientes.filter((c) => {
    const texto = busqueda.toLowerCase();
    return (
      c.nombre?.toLowerCase().includes(texto) ||
      
      c.dni?.toString().includes(texto)
    );
  });

  return (
    <div className="clientes-lista">
      <div className="encabezado-lista">
        <h1>Clientes</h1>
        <div className="acciones-lista">
          <input
            type="text"
            placeholder="Buscar por nombre o DNI..."
            value={busqueda}
            onChange={(e) => setBusqueda(e.target.value)}
            className="buscador"
          />
          {puedeCrearClientes && (
            <button onClick={onNuevo} className="btn-nuevo">
              + Nuevo Cliente
            </button>
          )}
        </div>
      </div>

<div className="clientes-mobile-list">
  {clientesFiltrados.map((cliente) => {
    const abierto = clienteAbiertoId === cliente.firebaseId;

    return (
      <div key={cliente.firebaseId} className="cliente-mobile-card">
        <div
          className="cliente-mobile-header"
          onClick={() =>
            setClienteAbiertoId((prev) =>
              prev === cliente.firebaseId ? null : cliente.firebaseId
            )
          }
        >
          <div>
            <strong>{cliente.nombre || "Sin nombre"}</strong>
            <span>Documento de identidad {cliente.dni || "-"}</span>
          </div>

          <span className="cliente-mobile-arrow">
            {abierto ? "⌃" : "⌄"}
          </span>
        </div>

        {abierto && (
          <>
            <div className="cliente-mobile-info">
              <p><b>Tel:</b> {cliente.telefono || "-"}</p>
              <p><b>Email:</b> {cliente.email || "-"}</p>
              <p><b>Dirección:</b> {cliente.direccion || "-"}</p>
              <p><b>Localidad:</b> {cliente.localidad || "-"}</p>
              <p><b>Provincia:</b> {cliente.provincia || "-"}</p>
            </div>

            <div
              className="cliente-mobile-actions"
              onClick={(e) => e.stopPropagation()}
            >
              <button onClick={() => onVer(cliente)}>Ver detalle</button>

              {puedeEditarClientes && (
                <button onClick={() => onEditar(cliente)}>Editar</button>
              )}
            </div>
          </>
        )}
      </div>
    );
  })}
</div>

<table className="clientes-table-desktop">
        <thead>
          <tr>
            <th>Documento de identidad</th>
            <th>Nombre</th>
            <th>Teléfono</th>
            <th>Dirección</th>
            <th>Localidad</th>
            <th>Provincia</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {clientesFiltrados.map((cliente) => (
            <tr
              key={cliente.firebaseId}
              className="fila-clickable"
              onClick={() => onVer(cliente)}
            >
              <td>{cliente.dni}</td>
              <td>{cliente.nombre}</td>
              <td>{cliente.telefono}</td>
              <td>{cliente.direccion}</td>
              <td>{cliente.localidad}</td>
              <td>{cliente.provincia}</td>
              <td
                className="acciones"
                onClick={(e) => e.stopPropagation()}
              >
                <ActionMenu
                  onVer={() => onVer(cliente)}
                  onEditar={
                    puedeEditarClientes ? () => onEditar(cliente) : undefined
                  }
                  onEliminar={
                    puedeEliminarClientes
                      ? () => eliminarCliente(cliente.firebaseId)
                      : undefined
                  }
                />
              </td>
            </tr>
          ))}
        </tbody>

      </table>

      {clientesFiltrados.length === 0 && (
        <p style={{ textAlign: "center", marginTop: "20px", color: "#888" }}>
          No se encontraron resultados para “{busqueda}”.
        </p>
      )}
    </div>
  );
}
